module.exports = __webpack_public_path__ + "media/images/mobile/Slider6-f224cca9f35d3750fb1fc93898bee93e.png";